import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 20px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
				
              <div className="col-md-7">
					
					<div className="pq-section pq-style-1 text-center">
					  <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
					</div>
					
					<div className="col-xl-12 mt-xl-0 ps-xl-3">
					  <div className="pq-accordion-block mt-4">
						{[ 
						  { question: "What is Tympanoplasty surgery?", answer: "Tympanoplasty is a surgical procedure to repair a hole or damage in the eardrum. It restores hearing, prevents repeated ear infections, and improves ear health. The surgeon uses a small graft to close the perforation and strengthen the eardrum for long-term protection." },
						  { question: "Who needs Tympanoplasty?", answer: "You may need Tympanoplasty if you have a long-term eardrum perforation, repeated ear discharge, reduced hearing, or infections not responding to medicines. An ENT specialist confirms the need through an ear examination and hearing tests like audiometry." },
						  { question: "How much does Tympanoplasty cost in Delhi?", answer: "The cost varies depending on the hospital, type of graft used, severity of the perforation, and whether ossicles also need repair. In most Delhi clinics, the price usually ranges based on individual evaluation. A consultation helps determine the exact estimate." },
						  {question: "How long is the recovery after Tympanoplasty?", answer: "Recovery is usually smooth, with most patients resuming normal routine in 1 week. Complete healing inside the ear may take 4–6 weeks. Patients should avoid water entry, loud noises, heavy lifting, and air travel until cleared by the ENT specialist."},
						  {question: "Is Tympanoplasty a safe and successful surgery?", answer: "Yes, Tympanoplasty is a safe, commonly performed surgery with a high success rate when done by an experienced ENT surgeon. It significantly improves hearing and prevents future infections. Regular follow-ups ensure proper healing and long-term results."}
						].map((item, index) => (
						  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
							<div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
							  <h4 className="ad-title-text">
								{item.question}
								<i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
							  </h4>
							</div>
							<div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
							  <p className="pq-detail-text">{item.answer}</p>
							</div>
						  </div>
						))}
					  </div>
					</div>
				</div>
				<div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                      <iframe width="100%" height="300px" src="https://www.youtube.com/embed/zGLdtuJfZZU" title="Tonsillectomy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
                      <div class="p-3"><h5 class="text-success mb-0">Explained Tympanoplasty Surgery (Eardrum Repair) | कान के पर्दे का ऑपरेशन | टिम्पैनोप्लास्टी सर्जरी</h5></div>
				  </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
